import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from '@Store';
import { HashRouter } from 'react-router-dom';

/**
 * @name wrapWithProvider
 * @param {ReactComponent} component
 * @description return function like "render Component to element"
 * returned function wraps Component with Redux provider and render result to DOM element
 * Common usage in Angular directives with has to render React component with store availability
 * @example
 * link: (scope, $element) => {
 * const container = $element.get(0);
 * wrapWithProvider(<ReactComponent />)(container);
 *  $element.on('$destroy', () => {
 *    ReactDOM.unmountComponentAtNode(container);
 *  });
 * }
 */
export default function wrapWithProvider(component) {
  return (el, props) => {
    const root = createRoot(el);
    root.render(
      <Provider store={store}>
        <HashRouter>{React.cloneElement(component, props)}</HashRouter>
      </Provider>
    );
    return root;
  };
}
